import { useRef } from 'react';
import { useMapStore } from '../store/mapStore';
export const useMap = () => {
    const mapRef = useRef(null);
    const isUpdatingRef = useRef(false);
    const { center, zoom, setCenter, setZoom, setBounds } = useMapStore();
    const initializeMap = (map) => {
        mapRef.current = map;
        isUpdatingRef.current = true;
        map.setView(center, zoom);
        // Initialize bounds immediately so useViewportMarkers fires on first load
        // without waiting for the user to move the map (moveend never fires on init).
        setBounds(map.getBounds());
        isUpdatingRef.current = false;
        map.on('moveend', () => {
            if (!isUpdatingRef.current) {
                const newCenter = map.getCenter();
                setCenter([newCenter.lat, newCenter.lng]);
                setBounds(map.getBounds());
            }
        });
        map.on('zoomend', () => {
            if (!isUpdatingRef.current) {
                setZoom(map.getZoom());
                setBounds(map.getBounds());
            }
        });
    };
    const panTo = (lat, lng, zoomLevel) => {
        if (mapRef.current) {
            isUpdatingRef.current = true;
            if (zoomLevel !== undefined) {
                mapRef.current.setView([lat, lng], zoomLevel);
            }
            else {
                mapRef.current.panTo([lat, lng]);
            }
            setTimeout(() => {
                isUpdatingRef.current = false;
            }, 100);
        }
    };
    const updateMapView = (newCenter, newZoom) => {
        if (mapRef.current) {
            isUpdatingRef.current = true;
            mapRef.current.setView(newCenter, newZoom);
            setTimeout(() => {
                isUpdatingRef.current = false;
            }, 100);
        }
    };
    return {
        mapRef,
        initializeMap,
        panTo,
        updateMapView,
    };
};
